import { render, staticRenderFns } from "./WorkFileIdentificationStep.vue?vue&type=template&id=4e6548da"
import script from "./WorkFileIdentificationStep.vue?vue&type=script&lang=ts"
export * from "./WorkFileIdentificationStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports